<template>
    <header id="header" class="">
        <div class="row">
            <div class="col-sm logo">
                <h1>Sabrina Pezzin</h1>
                <h2>Architecte</h2>
            </div>
            <nav class="col-sm">
                <ul class="d-flex flex-row-reverse">
                    <li><a href="#contact"  v-smooth-scroll>Contact</a></li>
                    <li><a href="#realisations" v-smooth-scroll>Réalisations</a></li>
                    <li><a href="#about" v-smooth-scroll>A propos</a></li>
                </ul>
            </nav>
        </div>
    </header>
</template>

<script>
    export default {
        name: "Header",
    }
</script>

<style scoped>

</style>
